import styled from "styled-components";

export const Wrapper = styled.div`
    /* width: 100%; */
    /* display: flex;
    flex-direction: row; */
`
export const Content = styled.div`
    color: #252427;
    font-family: "Baloo Bhai 2";
    width: 100px;
    background-color: rgba(255,255,255,0.14);
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    font-weight: 500;
    margin: 0 8px;
    text-align: center;
    
    :hover {
        border: 1px solid #0042ff;
    }
`